/**
 * Default sample question to pre-fill the prompt-test panel for each
 * clinical setting. Admins can edit before running.
 *
 * Keep these short, neutral, and evocative of the kind of question a real
 * user (parent or patient) would ask in that setting.
 */
export const PROMPT_TEST_SAMPLES: Record<string, string> = {
  // Validated 5
  'picu': 'What does intubated mean?',
  'preop': 'How do I prepare my child for surgery tomorrow?',
  'floor': 'When can my child come home?',
  'outpatient-peds': 'Why does my child need this antibiotic?',
  'outpatient-surgery': 'What is recovery like after a hernia repair?',
  // Adult specialties
  'adult-primary-care': 'What does my A1c result mean?',
  'adult-cardiology': 'What does ejection fraction mean?',
  'adult-neurology': 'Why was an MRI ordered?',
  'adult-nephrology': 'What does my creatinine result mean?',
  'adult-general-surgery': 'What does the pathology report say?',
  'adult-orthopedic-surgery': 'How long until I can bear weight?',
  'adult-endocrinology': 'What is my TSH telling me?',
  'adult-rheumatology': 'What does a positive ANA mean?',
  'adult-pulmonology': 'What does my pulmonary function test show?',
  'adult-urology': 'What is a PSA and is mine elevated?',
  'adult-cardiothoracic-surgery': 'What is recovery from CABG like?',
  'adult-trauma-surgery': 'Why was I taken to the OR?',
  // Pediatric specialties
  'peds-primary-care': 'Is my child growing normally?',
  'peds-cardiology': 'What does ejection fraction mean for my child?',
  'peds-neurology': 'Why does my child need an EEG?',
  'peds-nephrology': "What does my child's creatinine mean?",
  'peds-general-surgery': 'What is recovery from appendectomy like?',
  'peds-orthopedic-surgery': 'When can my child walk again?',
  'peds-endocrinology': 'What does an A1c mean for a child with type 1 diabetes?',
  'peds-rheumatology': 'What is JIA?',
  'peds-pulmonology': 'What is the asthma action plan for?',
  'peds-urology': 'What is a VCUG?',
  'peds-cardiothoracic-surgery': 'What is the Glenn procedure?',
  'peds-trauma-surgery': "What does my child's GCS score mean?",
};

export function getDefaultSampleQuestion(setting: string): string {
  return PROMPT_TEST_SAMPLES[setting] ?? 'Can you explain my recent visit?';
}
